import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
// import { ConfirmationService } from 'primeng/api';
import { IUser } from 'src/app/model/user';
import { EmailServiceComponent } from 'src/app/services/mail/email.service';
import { UserService } from 'src/app/services/user/user.service';
// import './../../../../assets/js/smtp/smtp.js';
import Swal from 'sweetalert2';

declare let Email: any;

@Component({
  selector: 'app-users-students',
  templateUrl: 'users-component.html',
  styleUrls: ['./users-component.scss']
})
export class UsersComponent {
  @Input() users:IUser[];
  @Input() showSpinner;
  @ViewChild("target1", { read: ElementRef, static: true }) target1ref: ElementRef; // gets #target1
  p: Number = 1;
  spinnerShare:boolean = false;
  count: Number = 4;
  elementSelected;
  hide = true;
  item;
  newItems: any;
  elementsToShare: any;
  isChangedItems: boolean;
  constructor(private emailService:EmailServiceComponent ,private confirmationService: ConfirmationService,
    
     private userService: UserService) {
      }

    public ngOnChanges(){
      console.log(this.users);
    }

  /**
   * 
   * @param event 
   * @param message 
   */
  confirm(event: Event, message) {
    this.confirmationService.confirm({
      target: event.target,
      message: message,
      acceptLabel: "ok",
      rejectVisible: false,

      icon: 'pi pi-info-circle',
      accept: () => {
        //confirm action
      },
      reject: () => {
        //reject action
      }
    });
  }


  

 

  /**
   * 
   * @param item 
   */
  public pop(item){
  
    this.hide = false;
    this.item = item;
    item["reason"] = item["reason"]?item["reason"]:"Aucune, juste par curiosité";

    Swal.fire({
      html:
        this.target1ref.nativeElement,
      showCloseButton: true,
      showConfirmButton:false,
      focusConfirm: false,
    })
  }
 /**
   *  Save the courses selected
   */
 public changeSelection(item) {
    console.log(item)
    this.hasItemsChanged(item);
  }

  private hasItemsChanged(itemSelected): void {

    const oldItem: IUser = this.newItems.filter(oldItem => oldItem.email == itemSelected.email);

    if (oldItem[0]. inscriptionConfirmed!== itemSelected.inscriptionConfirmed) {
      this.elementsToShare.push(itemSelected);
    }
    else {
      const index = this.elementsToShare.findIndex(item => item.email === itemSelected.email);
      if (index > -1) {
        this.elementsToShare.splice(index, 1);
      }

    }

     this.isChangedItems  = this.elementsToShare.length?true:false;

  }


  /**
   * 
   * @param elmt 
   * @returns 
   */
  public isSelected(elmt:any) {
    return elmt?elmt.selected:null;
  }


  /**
   * 
   * @param user 
   * @param event 
   */
  sendEmail(event) {
    
    let originalUser = {...this.elementSelected};
   // this.elementSelected.showSpinner = true;
   this.spinnerShare = true;

    this.emailService.sendEmail(this.users).then((message) => {
      if (message) {
        this.userService.update(this.elementSelected);
        this.confirm(event, `un mail a été envoyé à ${this.elementSelected.firstname} `);
      }
      else {
        this.confirm(event, `Un problème est survenue. Veuillez réessayer ultérieurement.`);
      }
      this.elementSelected.showSpinner = false;
      this.elementSelected = null;
      this.spinnerShare = false;
    },error=>{
      this.elementSelected.showSpinner = false;
      this.spinnerShare = true;

    });

  }

  public share(){

  }

}
